import Media from "./Media/Media"

const ScrollTop = () => {

  const ScrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }

  return(
    <>
      <div onClick={() => ScrollTop()}>
        <Media src="common/scroll-top" alt="上部に戻る" class="p-img__top"></Media>
      </div>
    </>
  )
}

export default ScrollTop;